import styled from "@emotion/styled";
import { FlowButtons, NewOrdersDialogWrapper } from "components/NewOrders/NewOrders.styles.ts";
import { Alert } from "@mui/material";

export const SelectCustomColorModalWrapper = styled(NewOrdersDialogWrapper)(({ theme }) => ({
	form: {
		display: "flex",
		flexDirection: "column",
		padding: "24px",
		h1: { ...theme.project.typography.heading.h6, margin: 0 },
		"> span:first-of-type": { ...theme.project.typography.body.body2, marginBottom: "16px" },
		"> span:last-of-type": {
			...theme.project.typography.body.body1,
			color: theme.project.colors.fontColors.secondary,
			marginBottom: "16px"
		},
		boxSizing: "border-box"
	}
}));

export const SelectCustomColorCatalogContentWrapper = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	gap: "16px"
}));

export const SelectCustomColorCatalogContent = styled.div(({ theme }) => ({
	display: "flex",
	gap: "16px",
	marginBottom: "16px",
	img: {
		alignSelf: "flex-start"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));

export const SelectCustomColorCatalogContentColumn = styled.div<{ width: number }>(({ theme, width }) => ({
	width: `${width}px`,
	display: "flex",
	flexDirection: "column",
	alignItems: "flex-start",
	img: {
		marginBottom: "8px"
	},
	"span:first-of-type": {
		...theme.project.typography.subtitle.subtitle2
	},
	"span:last-of-type": {
		...theme.project.typography.body.body2
	},
	[theme.breakpoints.down("md")]: {
		width: "100%"
	}
}));

export const SelectCustomColorModalContinueButtons = styled(FlowButtons)(({ theme }) => ({
	marginTop: 0,
	[theme.breakpoints.up("md")]: {
		display: "flex",
		button: {
			flex: 1,
			minWidth: "auto !important"
		}
	}
}));

export const SelectCustomColorModalErrorBanner = styled(Alert)({
	boxSizing: "border-box",
	marginBottom: "16px",
	div: { marginBottom: "4px" },
	p: { margin: 0 }
});
